<template>
  <div class="orders">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <OrdersTable :isReadOnly="isReadOnly" @create-order="onCreateOrder" @edit-order="onEditOrder" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import OrdersTable from '@/components/Orders/OrdersTable';
import { mapGetters } from 'vuex';
import { coversAccessLevel } from '@/helpers/accessLevel';
import { ORDERS_ACCESS_NODE } from '@/navigation/accessNodes';

export default {
  name: 'Orders',
  components: {
    Breadcrumbs,
    OrdersTable,
  },
  computed: {
    ...mapGetters(['getAccessLevel']),
    isReadOnly() {
      return !coversAccessLevel(this.getAccessLevel(ORDERS_ACCESS_NODE), 'editor');
    },
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('orders') }];
    },
  },
  methods: {
    onCreateOrder() {
      this.$router.push({ name: 'OrderCreatePage' });
    },
    onEditOrder(order) {
      this.$router.push({
        name: 'OrderEditPage',
        params: { orderNumber: order.number },
      });
    },
  },
};
</script>

<style lang="scss"></style>
